import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { useDispatch } from "react-redux";

// import Custom Components
import SideBar from "../../features/sidebar/shop-filter";
import ProductListByCategory from "../../features/product/list/product-list-bycategory";
import PageHeader from "../../common/page-header";
import Breadcrumb from "../../common/breadcrumb";

import { useInfiniteQuery } from "react-query";
import { getVariantsByCategorySlug } from "../../../api/queries/variants/variantsApi";
import { GET_VARIANT_BY_CATEGORY_SLUG } from "../../../constants/action-types";
import {
  extractEntitiesFromPages,
  normalizeInfiniteQueryStoreData,
} from "../../../utils/helpers";
import { SpecialLoadingOverlay } from "../../features/loading-overlay";

function VariantsByCategory(props) {
  const type = "boxed";
  const slug = props.match.params.slug;
  const title = {
    boxed: "Les Produits de la catégorie",
    fullwidth: "Les Variantes de la Catégorie",
  };

  const [variants, setVariants] = useState([]);
  const [isSlugChanged, setIsSlugChanged] = useState(false);
  const {
    isLoading,
    data,
    hasNextPage,
    fetchNextPage,
    isFetching,
  } = useInfiniteQuery(
    ["variants", slug],
    ({ pageParam }) => getVariantsByCategorySlug(slug, pageParam),
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        return lastPage.current_page < lastPage.total_pages
          ? lastPage.current_page + 1
          : undefined;
      },
      staleTime: 1000 * 60 * 10,
    }
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (type !== "boxed" && type !== "fullwidth") {
      window.location = process.env.REACT_APP_PUBLIC_URL + "/pages/404";
    }
  }, [type]);
  useEffect(() => {
    setIsSlugChanged(true);
  }, [slug]);

  useEffect(() => {
    //TODO use loadash for performance optimization

    if (!isFetching) {
      setIsSlugChanged(false);

      const loadedVariants = [...extractEntitiesFromPages(data.pages)];
      setVariants(loadedVariants);

      dispatch({
        type: GET_VARIANT_BY_CATEGORY_SLUG,
        normalizedVariantsByCategorySlug: normalizeInfiniteQueryStoreData(
          data.pages,
          data.pages.length
        ),
        variantsByCategorySlug: loadedVariants,
        variantsCount: data.pages[0].total_variants,
      });
    }
  }, [isFetching, slug]);

  function hideSideBar() {
    if (
      document.querySelector("body").classList.contains("sidebar-filter-active")
    )
      document.querySelector("body").classList.remove("sidebar-filter-active");
  }

  return (
    <>
      <Helmet>
        <title>Les produits de la Catégorie</title>
      </Helmet>

      <h1 className="d-none">Les produits de la catégorie</h1>

      <div className="main">
        <PageHeader title={slug} subTitle="Boutique" />

        <Breadcrumb
          title={title[type]}
          parent1={["Boutique", `shop/sidebar/list`]}
          adClass="mb-2"
          container={type === "boxed" ? "container" : "container-fluid"}
        />
        <div className="page-content">
          <div className={type === "boxed" ? "container" : "container-fluid"}>
            {variants.length ? (
              <ProductListByCategory
                type={type}
                variants={variants}
                variantsCount={data.pages[0].total_variants}
                isLoading={isLoading}
                isFetching={isFetching}
                fetchNextPage={fetchNextPage}
                isSlugChanged={isSlugChanged}
                hasNextPage={hasNextPage}
              />
            ) : isLoading ? (
              <SpecialLoadingOverlay />
            ) : (
              "pas de produits!"
            )}

            <div className="sidebar-filter-overlay" onClick={hideSideBar}></div>

            <SideBar numbers={50} />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(VariantsByCategory);
